/*
 * @Author: OnismYY
 * @Description: 所有菜单集合
 */
export default [
  {
    icon: 'mdi-account-cog-outline',
    text: 'menuName.userManage', //员工管理
    link: '/authority/sub-account',
    name: 'sub-account',
    menuKey: ['管理员']
  },
  {
    icon: 'mdi-map-marker-path',
    text: 'menuName.farmManage', //农场管理
    link: '/base-house/position-manage',
    name: 'position-manage'
    // menuKey: [""],
  },
  {
    icon: 'mdi-set-merge',
    text: 'alarmCenter.pushConfigure', //推送配置
    link: '/alarm-center/push-configure',
    name: 'push-configure'
    // menuKey: ['管理员']
  },
  {
    text: 'menuName.productAdd', //产品添加
    link: '/scan-bind',
    icon: 'mdi-printer-pos-plus-outline'
  }
]
